import React, { useContext } from 'react'
import Slider from './Slider'
import { IoLocationSharp } from 'react-icons/io5'
import CarouselTwoImageSlider from './CarouselTwoImageSlider'
import SlideSocialMedias from './SlideSocialMedias'
import { CardContext } from '../../store/CardContext'
import BasicInfoSection from './BasicInfoSection'

function Home() {

    const [cardData] = useContext(CardContext)
    // console.log(cardData, 'cardData');
    const {
        logo,
        basicInfo,
        personalInfo,
        devInitiative,
        colors,
        gallery,
    } = cardData

    const imgOverTxtColor = colors?.imgOverTxtColor ? colors?.imgOverTxtColor : "white"
    const txtColor = colors?.txtColor ? colors?.txtColor : "black"
    const iconColor = colors?.iconColor ? colors?.iconColor : "black"
    const btnTxtColor = colors?.btnTxtColor ? colors?.btnTxtColor : "white"
    const btnColor = colors?.btnColor ? colors?.btnColor : "black"
    const bgColor = colors?.bgColor ? colors?.bgColor : "white"


    return (
        <div>
            <div className="HomeProfile  relative " >
                <div className="Homeprofile_banner relative">
                    <img src={personalInfo?.profileImg} className="user h-[550px] w-[393px] object-cover" alt="homebanner" />
                    <div className="pillersOfAsoka absolute left-[22px] top-[25px]">
                        <img src={logo} />
                    </div>
                    <div className="nameWrap absolute  left-[22px] bottom-[35px] max-w-[90vw]" style={{color:imgOverTxtColor}} >
                        <p className="text-lg  font-semibold pb-1">{personalInfo?.name}</p>
                        <p className="text-sm  font-medium pb-1">{personalInfo?.designation}</p>
                        <div className="flex gap-2 ">
                            <IoLocationSharp  size={20} />
                            <p className=" text-sm font-normal">{personalInfo?.location}</p>
                        </div>
                    </div>
                </div>
                <div className="m-5" style={{color:txtColor}} >
                    <div className="flex gap-3 justify-center items-center">
                        <img src={logo} alt="logohome" />
                    </div>
                    <div>
                        <p className="font-semibold text-base mt-5  text-center">
                            {basicInfo?.heading}
                        </p>
                        <BasicInfoSection itemDatas={basicInfo?.contents} txtColor={txtColor} iconColor={iconColor} />
                    </div>
                    <div className="mt-5">
                        <p className="font-semibold text-base  text-center mb-5 ">
                            {devInitiative?.heading}
                        </p>
                        <CarouselTwoImageSlider images={devInitiative?.contents} bgColor={bgColor} txtColor={txtColor} btnColor={btnColor} btnTxtColor={btnTxtColor} />
                    </div>
                    <div className="mt-5">
                        {/* <p className="font-semibold text-base text-black text-center ">Socials</p> */}
                        <SlideSocialMedias preview={"preview"} txtColor={txtColor} color={iconColor} />
                    </div>
                    <div className="mt-10">
                        <p className="font-semibold text-base text-center  mb-5 ">{gallery?.heading}</p>
                        <Slider data={gallery?.images} />
                    </div>

                </div>

            </div>

        </div>
    )
}

export default Home